// xyz-crossection.js
// along with crosssection-worker-xyz.js, this paints a <canvas>
// with cross-sections of the P3 gamut in the XYZ colorspace
// at a given Y value, that's alterable with an <input>

// note to self
// if I were gonna break this out into a re-usable module...
// inputs would be... size, canvas, worker, input, output


// this controls how many pixels we're calculating
// we'll scale the result up
// main purpose is to determine how much work we're doing
// knob to adjust how jagged/chunky vs slow-to-update the output is
const size = 200;

const canvasEl = document.querySelector( '#xyz-crosssection' );
canvasEl.width = size;
canvasEl.height = size;

// an offscreen canvas in a worker is going to be doing all the work
// vite needs it to be a URL()??
// https://vitejs.dev/guide/features.html#web-workers
const worker = new Worker(new URL('./crosssection-worker-xyz.js', import.meta.url), {
  type: 'module',
} );
// const worker = new Worker( './crosssection-worker-xyz.js', { type: 'module' } );
const offscreenCanvas = canvasEl.transferControlToOffscreen();
worker.postMessage( { canvas: offscreenCanvas }, [ offscreenCanvas ] );

// listen to input for changing where we're taking the crosssection
const input = document.querySelector('#y');
const output = document.querySelector('output[for=y]')
const update = () => {
	output.textContent = input.value;
	worker.postMessage( { y: input.value } );
}

input.addEventListener( 'input', update );

// fix disappearing cross-sections when tabbing away/back
document.addEventListener( "visibilitychange", () => {
	if ( document.visibilityState === "visible" ) {
		worker.postMessage( { y: input.value } );
	}
} );

// initial update
update();